import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

function normalizeApiMessageWithFallbackKey(
  payload,
  fallbackMessage,
  fallbackKey,
) {
  const normalized = normalizeApiMessage(payload, fallbackMessage);
  return {
    ...normalized,
    messageKey: /^(PROJECT_NODE_|INVALID_PROJECT_NODE_)/.test(payload?.code ?? "")
      ? "" : normalized.messageKey || fallbackKey || "",
  };
}

function normalizeFusionResultCode(value) {
  const n = Number(value);
  return Number.isFinite(n) && [0, 1, 2, 3].includes(n) ? n : null;
}

export async function postUpdateFile(Form) {
  if (!Form || typeof Form !== "object" || !Form.id) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Invalid file update request." },
        "Invalid file update request.",
        "api.project.file.update.validation.invalidRequest",
      ),
    };
  }

  const form = {
    id: Form.id ?? "",
    facility_type: Form.facility_type ?? "",
    facility_name: Form.facility_name ?? "",
    part_name: Form.part_name ?? "",
    building_name: Form.building_name ?? "",
    floor: Form.floor ?? "",
    location: Form.location ?? "",
    serial_number: Form.serial_number ?? "",
    equipment_used: Form.equipment_used ?? "",
    inspection_result: Form.inspection_result ?? " ",
    fusion_result: normalizeFusionResultCode(
      Form.fusion_result_code ?? Form.fusion_result,
    ),
    ambient_temp: Form.ambient_temp ?? "",
    operating_voltage: Form.operating_voltage ?? "",
    measurement_conditions: Form.measurement_conditions ?? "",
    measured_by: Form.measured_by ?? "",
    upload_id: Form.upload_id ?? "",
    project_id: Form.project_id ?? "",
  };

  console.log(form.fusion_result);

  try {
    const path = `${BACKEND_URL}/project/update_file`;

    const res = await authFetch(
      path,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (res.status === 401) {
      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          { message: "Session expired. Please sign in again." },
          "Session expired. Please sign in again.",
          "api.auth.token.expired",
        ),
      };
    }

    const data = await res.json().catch(() => null);
    if (!data) {
      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
          "api.common.serverError",
        ),
      };
    }

    if (!res.ok || data?.success !== true) {
      const fallbackKey =
        res.status === 404
          ? "api.project.file.update.notFound"
          : res.status === 400
            ? "api.project.file.update.validation.invalidRequest"
            : "api.project.file.update.failed";

      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          data,
          "Update failed.",
          fallbackKey,
        ),
      };
    }

    return {
      success: true,
      ...normalizeApiMessageWithFallbackKey(
        data,
        "Updated successfully.",
        "api.project.file.update.success",
      ),
    };
  } catch (error) {
    console.error("postUpdateFile request failed:", error);
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Server request failed." },
        "Server request failed.",
        "api.common.networkError",
      ),
    };
  }
}
